const points = (skillPoints, updatedSkillsLvels, skillLevels, index) =>
    skillPoints - (updatedSkillsLvels[index] - skillLevels[index])

const index = (skillLevels, index) =>
    skillLevels[index] === 0 ? 0 : skillLevels[index] - 1

const pointsForThirdClass = (thidClassLevel) =>
    !thidClassLevel ? 147 : 147 + parseInt(thidClassLevel) * 3

const getsSkillCooldown = (cooldownPercent, skillCooldown) =>
    cooldownPercent > 0
        ? Math.floor(skillCooldown * (1 - cooldownPercent))
        : skillCooldown

const getSkillCast = (skillCast) =>
    skillCast === 0 ? "Instantâneo" : skillCast

export { points, index, pointsForThirdClass, getsSkillCooldown, getSkillCast }
